<template>
  <div>
    <div v-for="song in songs" v-bind:key="song.id" class="px-1 mb-1">
      <div
        class="bg-dark px-4 py-1 d-block d-flex justify-content-start align-items-center rounded clickable"
        :class="{ 'song-already-added': isPlaylistContext && isAlreadyInPlaylist(song) }"
      >
        <span
          class="py-2 pr-2 mr-2 text-muted"
          :style="{ minWidth: '30px' }"
        >
          <span class="font-button" v-if="song.preview_url != null && song.preview_url !== ''" @click="previewClick(song)">
            <span :style="{ display: !isPlaying && previewSongId === null ? 'block' : 'none' }">
              <FontAwesomeIcon icon="play" class="text-primary"/>
            </span>
            <span :style="{ display: !isPlaying && previewSongId !== null && song.id === previewSongId ? 'block' : 'none' }">
              <FontAwesomeIcon icon="pause" class="text-primary"/>
            </span>
          </span>
        </span>
        <SongCover
          :coverUrl="song.cover_url"
          :alt="song.title + ' cover'"
          :size="40"
          class="mr-3"
        />
        <div>
          <p class="m-0 p-0" :class="isPlaylistContext && isAlreadyInPlaylist(song) ? 'text-muted' : 'text-white'">{{ song.title }}<br>
            <small class="text-muted">{{ song.artist }} - {{ song.minutesAndSeconds }}</small>
          </p>
        </div>
        <template v-if="isPlaylistContext && isAlreadyInPlaylist(song)">
          <span class="ml-auto far-right-option">
            <FontAwesomeIcon icon="check" class="i text-muted"/>
          </span>
        </template>
        <template v-else>
          <span
            @click.stop="handleAdd(song)"
            :style="{ display: !requestQueue.has(song.id) ? 'inline-block' : 'none' }"
            class="ml-auto far-right-option font-button"
          >
            <FontAwesomeIcon icon="plus" class="i text-primary"/>
          </span>
          <span
            :style="{ display: requestQueue.has(song.id) ? 'inline-block' : 'none' }"
            class="ml-auto far-right-option"
          >
            <FontAwesomeIcon icon="spinner" spin />
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import musicboxClient from '@/utils/musicboxClient'
import audioManager from '@/utils/audioManager'
import SongCover from '@/components/shared/SongCover.vue'

export default {

  name: 'SongDiv',

  components: {
    SongCover
  },

  beforeDestroy () {
    if (this.preview != null) {
      this.preview.pause()
      this.preview = null
    }
  },

  data () {
    return {
      requestRunning: false,
      preview: null,
      previewSongId: null,
      requestQueue: new Set()
    }
  },

  computed: {
    isPlaying () {
      return this.$store.state.audio.audioPlaying
    },
    isWebBox () {
      return this.$store.state.audio.currentBox.is_web
    },
    isPlaylistContext () {
      return this.$route.query && this.$route.query.playlist === 'create'
    },
    playlistSongIds () {
      const edited = this.$store.state.playlistEdit.editedPlaylist
      if (!edited || !edited.songList) { return new Set() }
      return new Set(edited.songList.map(s => s.id))
    }
  },

  methods: {
    isAlreadyInPlaylist (song) {
      return this.playlistSongIds.has(song.id)
    },
    handleAdd (song) {
      if (this.isPlaylistContext) {
        if (this.isAlreadyInPlaylist(song)) { return }
        this.$store.commit('updateEditedPlaylist', { key: 'songList', value: song })
        this.$notify.success(this.$t('Added {songTitle}', { songTitle: song.title }))
      } else {
        this.addToQueue(song)
      }
    },
    addToQueue (song) {
      const songId = song.id
      if (this.$store.state.audio.currentBox == null || this.requestQueue.has(songId)) { return }
      this.requestQueue.add(songId)
      this.requestQueue = new Set(this.requestQueue)
      musicboxClient
        .addSongToQueue(this.$store.state.audio.currentBox.uuid, { song_id: songId })
        .then(res => {
          this.$notify.success(this.$t('Enqueued {songTitle}', { songTitle: song.title }))
          audioManager.forceUpdateStatus()
        })
        .catch(e => {
          this.$notify.danger(this.$t('Failed to enqueue {songTitle}', { songTitle: song.title }))
        })
        .then(() => {
          this.requestQueue.delete(songId)
          this.requestQueue = new Set(this.requestQueue)
        })
    },
    previewClick (song) {
      if (this.isPlaying || song.preview_url == null || song.preview_url === '') { return }
      if (this.previewSongId != null) {
        if (this.previewSongId === song.id) {
          this.preview.pause()
          this.preview = null
          this.previewSongId = null
        }
        return
      }
      this.preview = new Audio(song.preview_url)
      this.previewSongId = song.id
      this.preview.onended = () => {
        this.preview = null
        this.previewSongId = null
      }
      this.preview.play()
    }
  },

  props: {
    songs: Array
  }

}
</script>

<style scoped>
.song-already-added {
  opacity: 0.45;
  pointer-events: none;
  cursor: default;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/SongsList.vue